import React from "react";

function PageNotFoundPage() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-1/2 p-8 text-gray-600">
        <h1 className="text-6xl font-bold mb-4">404: Page not Found</h1>
        <div className="border-t-2 border-gray-200 pt-8">
          <p className="text-2xl">The page you requested could not be found.</p>
        </div>
      </div>
    </div>
  );
}

export default PageNotFoundPage;
